import { NgApiClient } from '@src/api/ngApiClient';
import { AnyType } from '@src/models/common';
import { TFilterScheme } from '../models';

export const fetchOptions = async (filter: TFilterScheme, ngApiClient: NgApiClient, data: AnyType) => {
  if (filter.type !== 'options') return null;

  try {
    if (filter.source === 'external') {
      return await filter.getOptions({ ngApiClient, data });
    } else {
      const result = await ngApiClient.get<AnyType[], string>(filter.api.entity, {
        selector: filter.api.selector,
      });
      return result.data.page.entries;
    }
  } catch (error) {
    return null;
  }
};
